import { imageResolutions, imageFilters } from '@/constants/image'

export const S3Trim = {
  methods: {
    /**
     * @param   {string}  url
     * @param   {string}  resolution
     * @param   {boolean} transform
     *
     * @returns {string}
     */
    s3Trim (url, resolution = imageResolutions.THUMBNAIL, transform = true) {
      if (!url) {
        return ''
      }

      const parsedUrl = new URL(url)
      let urlParameters = ''

      if (transform) {
        const format = this.$webpSupport ? 'webp' : 'png'
        const additionalFilters = imageFilters[resolution] || []
        const secondaryFilters = [
          'filters',
          ...additionalFilters,
          `format(${format})`
        ]

        const filtersUrlParametersArray = [
          'trim',
          'fit-in',
          resolution,
          secondaryFilters.join(':')
        ]
        urlParameters = `/${filtersUrlParametersArray.join('/')}`
      }

      if (parsedUrl.hostname === 's3') {
        return url
      }

      parsedUrl.pathname = `${urlParameters}${parsedUrl.pathname}`

      return parsedUrl.href
    }
  }
}
